import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const NOINDEX_PATTERN = /^\/(admin(\/|$)|login\/?$|unauthorized\/?$)/;

const upsertRobotsMeta = (content) => {
  let tag = document.querySelector('meta[name="robots"]');
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', 'robots');
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
};

/**
 * Keeps robots meta in sync during client-side navigation (SPA).
 * Crawlers get the server-injected tags; this covers in-app route changes.
 */
export default function ClientSeo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const noindex = NOINDEX_PATTERN.test(pathname);
    upsertRobotsMeta(noindex ? 'noindex, nofollow' : 'index, follow');
  }, [pathname]);

  return null;
}
